import { Box } from '@mui/material';
import { NoteSection } from '../../notes-page/components/NoteSection';
import { ServerForm } from '@uplift/ui-v2';
import { DiagnosisSelect } from '../../../components';
import { ClaimCorrectionFormType, Diagnosis } from '@uplift/types';
import { useAmendSectionStyles } from './styles';
import { SessionFormField, SessionFormFieldsGroup } from '@uplift/api';
import { useFormikContext } from 'formik';
import { NoteSectionCloseButton } from '../../notes-page/components/NoteSectionCloseButton';
import { useMemo } from 'react';
import { EMPTY_STRING } from '@uplift/constants';

export type AmendDiagnosisSectionProps = {
  open: boolean;
  diagnoses: Diagnosis[];
  diagnosisCodeChangeReason: (SessionFormField | SessionFormFieldsGroup)[];
};

export const AmendDiagnosisSection: React.VFC<AmendDiagnosisSectionProps> = ({ open, diagnoses, diagnosisCodeChangeReason }) => {
  const { classes } = useAmendSectionStyles();
  const formik = useFormikContext<ClaimCorrectionFormType>();

  const handleClose = () => {
    formik.setFieldValue('claim.diagnosis_field_toggle', false);
    formik.setFieldValue('claim.diagnosis_code_change_reason', null);
    formik.setFieldValue('diagnosis', []);
  };

  const closeIcon = useMemo(() => {
    if (formik?.values.claim['diagnosis_code_change_reason'] !== null && formik.values.claim['diagnosis_code_change_reason'] !== EMPTY_STRING) {
      return true;
    }
    if (formik?.values.diagnosis.length > 0) {
      return true;
    }
    return false;
  }, [ formik.values.claim, formik.values.diagnosis.length ]);

  if (!open) {
    return null;
  }

  return (
    <NoteSection
      title="Amend Diagnosis"
      className={classes.noteSectionContent}
      onDelete={<NoteSectionCloseButton onDelete={handleClose} closeIcon={closeIcon} />}
    >

      <Box className={classes.section}>
        <ServerForm fields={diagnosisCodeChangeReason} namespace="claim"/>
      </Box>
      <Box pl={3} pt={3}>

        <DiagnosisSelect
          name="diagnosis"
          diagnoses={diagnoses}
          color="secondary"
          chipClassName={classes.chip}
          buttonTextVariant
        />
      </Box>
    </NoteSection>
  );
};
